export default __webpack_public_path__ + "static/media/Ballroll_00235.e47ab244.png";